export function extractFromDataField<T>(response: any): T | null {
  return !response ? null : 'data' in response ? response.data : response;
}
